<template>
  <div :class="['v2-menu', {bg: bg}]">
    <div class="v2-wrap clearfix">
      <router-link class="logo-wrap" to="/">
        <img class="logo-img" src="~@/assets/images/v2/logo.png" alt="" />
      </router-link>

      <div class="page-title" v-if="pageTitle && pageTitle.length > 0">{{pageTitle}}</div>
      <div class="menu-search clearfix" v-else>
        <div class="menu-list clearfix">
          <router-link to="/" class="menu-item">首页</router-link>
          <router-link to="/v2/homestay" class="menu-item">民宿</router-link>
<!--          <router-link to="/b" class="menu-item">认种认养</router-link>-->
<!--          <router-link to="/c" class="menu-item">农业体验</router-link>-->
<!--          <router-link to="/d" class="menu-item">美食</router-link>-->
<!--          <router-link to="/e" class="menu-item">农产</router-link>-->
<!--          <router-link to="/e" class="menu-item">攻略</router-link>-->
        </div>
        <div class="search-wrap">
          <el-input
            class="search-ipt"
            v-model="search"
            :placeholder="placeholder"
            clearable
          />
          <div class="search-btn" @click="searchEv"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      bg: {
        type: Boolean,
        default: false
      },
      pageTitle: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '请输入搜索内容'
      }
    },
    data () {
      return {
        search: ''
      }
    },
    methods: {
      searchEv () {
        console.log(this.search)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v2-menu {
    position: fixed;
    z-index: $z-index-v2;
    top: $head-height-v2;
    width: 100%;
    height: $menu-height-v2;
    padding-top: ($menu-height-v2 - 44px) / 2;
    background: $bg-color-v2;
    box-shadow: 0 0 10px $bg-color-v2;

    &.bg {
      background: #fff;
    }

    .logo-wrap {
      float: left;
      height: 44px;

      .logo-img {
        height: 100%;
      }
    }

    .page-title {
      float: left;
      margin-left: 60px;
      color: #363A44;
      font-size: 28px;
      line-height: 44px;
    }

    .menu-search {
      float: right;
      width: 965px;
      height: 44px;

      .menu-list {
        float: left;
        padding-top: 15px;

        .menu-item {
          float: left;
          margin: 0 24px;
          color: #363A44;
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;

          &:hover {
            color: $light-color-v2;
          }

          &.router-link-exact-active {
            position: relative;

            &:after {
              position: absolute;
              bottom: -7px;
              left: 50%;
              content: '';
              display: block;
              width: 30px;
              height: 3px;
              margin-left: -15px;
              background: $light-color-v2;
            }
          }

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .search-wrap {
        position: relative;
        float: right;
        width: 400px;
        margin-top: 4px;
        padding-right: 60px;

        >>> .search-ipt {
          .el-input__inner {
            height: 36px !important;
            line-height: 32px !important;
            border: 2px solid $light-color-v2 !important;
            border-right: none !important;
            border-radius: 20px 0 0 20px !important;
            background: none !important;
          }

          .el-input__suffix {
            .el-input__icon {
              line-height: 36px !important;
            }
          }
        }

        .search-btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 60px;
          height: 36px;
          background-color: $light-color-v2;
          background-image: url('~@/assets/images/v2/search.png');
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 20px 20px;
          border-radius: 0 20px 20px 0;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/saas/v2/Menu.vue